export const appRoutes = {
  root: '/',
  dashboard: '/dashboard',
  myPlan: (year) => `/my-plan/${year}`,
  planCalendar: (officerId, planYear) => `/officer-plans/${officerId}/${planYear}`,
  holiday: (year) => `/holiday/${year}`,
  addHoliday: (year) => `/holiday/${year}/add-holiday`,
  sessionList: `/plan-session-list`,
  createNotice: `/create-notice`,
  submissionStat: (year) => `/plan-submission-stat/${year}`,
  submissionDetails: (selectedYear, zoneId) =>
    `/plan-submission-details/${selectedYear}?zoneId=${zoneId}`,
  isasComplaintDetails: (selectedYear, zoneId) =>
    `/isas-complaint-details/zone/${zoneId}/year/${selectedYear}`,
  addVisitPlanSession: '/add-session-plan',
  sessionPlan: (id) => `/session-plan/${id}`,
  updateSessionPlan: (id) => `/update-session-plan/${id}`,
  addVisitPlan: (sessionId) => `/plan-session/${sessionId}/add-visit-plan`,
  revisedPlan: (zoneId, year) => `/plan-to-be-revised/zone/${zoneId}/year/${year}`,
  noticeDetails: (id) => `/notice-details/${id}`,
  UserNoticeDetails: (id) => `/user-notice-details/${id}`,
  noticeManagement: '/notice-management',
  noticeList: '/notice-list',
  createNoticeSuccess: '/notice-creation/succeed',
  updateNoticeSuccess: '/notice-updation/succeed',
  deleteNoticeSuccess: '/delete-notice/success',
  createNoticeFail: '/notice-creation/failed',
  updateNoticeFail: '/notice-updation/failed',
  updateNotice: (id) => `/update-notice/${id}`,
  curriculumMonitoring: 'monitoring/1',
  officerList: '/officer-list',
  monitoringBI: '/monitoring-bi',
  officerDetails: (officerId) => `/officer-details/${officerId}`,
  userProfile: '/profile',
  instituteList: '/institute-list',
  instituteDetails: (eiin) => `/institutes/${eiin}`,
  auditLog: '/audit-log',
  institutionReport: '/report/institution',
  officeReport: '/report/office',
  curriculumReport: '/report/curriculum',
  generalVisits: '/general-visits',
  generalVisitDetails: (visitId) => `/general-visits/${visitId}`,
  curriculumVisits: '/curriculum-visits',
  curriculumVisitDetails: (visitId) => `/curriculum-visits/${visitId}`,
  officeVisits: '/office-visits',
  officeVisitDetails: (visitId) => `/office-visits/${visitId}`,
  monitoringSubjectiveReport: (type) => `/monitoring-subjective-report/${type}`,
  othersReport: '/report/others',
  dynamicSurveyReport: '/report/dynamic-survey',
  planSubmissionReport: '/report/others/plan-submission',
  officeInstituteSummaryReport: '/report/others/office-institute-summary-report',
  monitoringPlanReport: '/report/institution/monitoring-plan',
  monitoringActivitiesCompletedReport: '/report/institution/monitoring-activities-completed',
  monitoringActivitiesCompletedDelayReport:
    '/report/institution/monitoring-activities-completed-delay',
  monitoringActivitiesIncompleteReport: '/report/institution/monitoring-activities-incomplete',
  monitoringActivitiesFullyIncompleteReport:
    '/report/institution/monitoring-activities-fully-incomplete',

  auditFailed: '/audit/failed',
  settings: '/settings',
  helpCenter: '/help-center',
  settingsSuccess: '/settings/succeed',
  settingsfail: '/settings/failed',
  monitoringPlanNotFound: '/officers-monitoring-plan/not-found',
  surveyFormError: '/survey-form-fetching/failed',
  monitoringSurveyBI: (type) => `/survey-monitoring-bi/${type}`,
  instituteMonitoringAbsentReport: '/report/institution/monitoring-teacher-staff-absent-count',
  instituteMonitoringAbsentDetailsReport:
    '/report/institution/monitoring-teacher-staff-absent-details',
  officeMonitoringAbsentReport: '/report/office/monitoring-officer-staff-absent-count',
  officeMonitoringAbsentDetailsReport: '/report/office/monitoring-officer-staff-absent-details',
  officeMonitoringSummaryReport: '/report/office/monitoring-summary',
  redirectToSSO: '/login/redirect-to-sso',
  createForm: '/form/create',
  updateForm: (id) => `/form/edit/${id}`,
  detailForm: (id) => `/form/detail/${id}`,
  manageForm: `/form/management`,
  saveFormSuccess: '/save-form/succeed',
  updateFormSuccess: '/update-form/succeed',
  saveFormFail: '/save-form/failed',
  surveyList: '/form/survey-list',
  surveyManagement: '/form/management',
  dynamicSurveyManagement: '/dynamic-survey/management',
  dynamicSurveyList: '/dynamic-survey/list',
  createDynamicSurvey: '/dynamic-survey/create',
  updateDynamicSurvey: (id) => `/dynamic-survey/update/${id}`,
  publishDynamicSuccess: '/dynamic-survey-publish/succeed',
  updateDynamicSuccess: '/dynamic-survey-update/succeed',
  guestUserRegistration: '/guest-user/registration',
  guestUserEdit: (userId) => `/guest-user/edit/${userId}`,
  guestUserList: '/guest-user/list',
  saveGuestUserSuccess: '/guest-user/succeed',
  updateGuestUserSuccess: '/guest-user-update/succeed',

  // Well-being
  wellBeingSessions: '/well-being/sessions',
  wellBeingCreateSession: '/well-being/sessions/create',
  wellBeingUpdateSession: (sessionId) => `/well-being/sessions/${sessionId}/edit`,
  wellBeingSessionDetails: (sessionId) => `/well-being/sessions/${sessionId}`,
  wellBeingSubmissionList: (sessionId) => `/well-being/sessions/${sessionId}/submissions`,
  wellBeingSubmissionDetails: (submissionId) => `/well-being/submissions/${submissionId}`,
  wellBeingMyTasks: '/well-being/my-tasks',
  wellBeingFormSubmission: () => `/well-being/my-task/form`,
  wellBeingMonitoring: '/monitorings/well-being',
  wellBeingInstituteReport: '/report/institution/well-being',
};
